import React from 'react';
import { Box, Button, Paper, Stack, Typography } from '@mui/material';
import { Building2, SearchX } from 'lucide-react';

interface EntityTreeEmptyStateProps {
  searchQuery?: string;
  onClearSearch?: () => void;
  onAddClick?: () => void;
}

export const EntityTreeEmptyState: React.FC<EntityTreeEmptyStateProps> = ({
  searchQuery,
  onClearSearch,
  onAddClick,
}) => {
  const isSearchEmpty = Boolean(searchQuery && searchQuery.trim());

  return (
    <Paper
      elevation={0}
      sx={{
        p: 6,
        textAlign: 'center',
        borderRadius: '14px',
        border: '1px dashed #cbd5e1',
        bgcolor: '#f8fafc',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box
        sx={{
          width: 56,
          height: 56,
          borderRadius: '50%',
          bgcolor: isSearchEmpty ? 'rgba(239, 68, 68, 0.08)' : 'rgba(59, 130, 246, 0.08)',
          color: isSearchEmpty ? '#ef4444' : '#3b82f6',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mb: 2,
        }}
      >
        {isSearchEmpty ? <SearchX size={28} /> : <Building2 size={28} />}
      </Box>

      <Typography variant="h6" sx={{ fontSize: '1rem', fontWeight: 700, color: '#1e293b', mb: 0.5 }}>
        {isSearchEmpty ? 'No matching partner entities' : 'No partner entities found'}
      </Typography>

      <Typography variant="body2" sx={{ color: '#64748b', maxWidth: 400, mb: 3 }}>
        {isSearchEmpty
          ? `We couldn't find any partner entities matching "${searchQuery}". Check the spelling or try a different term.`
          : 'Organize your partner network hierarchically. Add your first partner organization to begin.'}
      </Typography>

      {isSearchEmpty && onClearSearch && (
        <Button
          variant="outlined"
          size="small"
          onClick={onClearSearch}
          sx={{
            textTransform: 'none',
            borderRadius: '8px',
            borderColor: '#e2e8f0',
            color: '#3b82f6',
            '&:hover': {
              borderColor: '#93c5fd',
              bgcolor: 'rgba(59, 130, 246, 0.04)',
            },
          }}
        >
          Clear search
        </Button>
      )}
    </Paper>
  );
};
